// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cfde9f66","453":"686ce2d1","553":"d981e62c"}[chunkId] + ".chunk.js";
};